import React from 'react';
import api from '../../../store/api'
import {updateUserDataAfterLogin} from '../../../store/calls/index';
import {addAlertWithTimeout} from '../../../store/calls/alertLoadingDispatch'
import {store} from '../../../store/index'
import {setData as setUserData} from '../../../store/actions/user'

export default class ActivateUser extends React.Component {


    componentDidMount() {

        api.get('/activate-account/'+this.props.location.search)
            .then((res) => {
                let token = res.data.tokens.access;
                updateUserDataAfterLogin(token)
                addAlertWithTimeout({
                    type: 'success',
                    title: 'Account Created!',
                    body: 'Thanks for joining CleanFi.',
                    sticky: true
                })
                store.dispatch(setUserData(res.data.user))
                this.props.history.push(this.getRedirectUrl())

            })
    }

    getRedirectUrl = () => {
        const searchParams = new URLSearchParams(this.props.location.search)
        //if there is a product, take them to loan estimate screen
        if (searchParams.get('p')) {
            return '/project-estimate/' + searchParams.get('p')
        } else {
            return '/'
        }
    }


    render() {
        return (
            <div className={'m-6'}>
                <h3>Activating User. If not redirected, <a href={this.getRedirectUrl()}>click here</a>.</h3>
            </div>
        )
    }
}